import Layout from "../components/layout";
import FormInput from "../components/formInput";
import React, {useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cn from "classnames";
import {useHistory} from "react-router";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {AuthContext} from "../contexts/auth";
import {toast} from "react-toastify";

function LoginView() {


    const [state, dispatch] = React.useContext(AuthContext)

    /*
    *   0 - pre login
    *   1 - email send
    *   2 - username change
    */
    const [loginState, setLoginState] = useState(0);
    const [email, setEmail] = useState("");
    const [otp, setOTP] = useState("");
    const [validated, setVaildated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");

    let history = useHistory();

    useEffect(() => {
        if (state.auth) {
            history.push("/")
        }
    }, [])

    const ref = useRef();

    const onBack = e => {
        e.preventDefault();
        e.stopPropagation();

        setLoginState(0);
        setOTP("")
    }

    const onRetry = e => {
        e.preventDefault();
        e.stopPropagation();
    }

    const onLogin = e => {
        e.preventDefault();
        e.stopPropagation();

        if (!ref.current.checkValidity()) {
            setVaildated(true);
            return;
        }

        setVaildated(false);
        setLoading(true);

        let cleanEmail = email.trim();

        setUsername(cleanEmail.split("@")[0])

        // eslint-disable-next-line default-case
        switch (loginState) {
            case 0:
                axios({
                    method: "post",
                    url: Endpoints.LOGIN,
                    data: {
                        email: cleanEmail
                    }
                }).then(res => {
                    setLoading(false)
                    setLoginState(1)
                }).catch(err => {
                    if (err.response && err.response.status) {
                        setLoading(false)
                        switch (err.response.status) {
                            case 400:
                                toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                                break;
                            case 404:
                                toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                                break;
                            case 401:
                                if (err.response.data.code === 1015) {
                                    toast.warn("Hey du, leider wurde dein User deaktiviert! Bitte frag bei Jani nach, um mehr zu erfahren.")
                                    break;
                                }
                                toast.error("Wir können dich grade nicht einloggen. Bitte versuche es später noch einmal.")
                                break;
                            default:
                                toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                                break;
                        }
                    }
                })

                return;
            case 1:
                axios({
                    method: "post",
                    url: Endpoints.OTP,
                    data: {
                        email: cleanEmail,
                        otp: otp.toString(),
                    }
                }).then(res => {

                    setLoading(false)
                    dispatch({
                        type: "login", payload: {
                            token: res.data.token.token,
                            username: username,
                            preferences: res.data.user.preferences,
                        }
                    })

                    if (!res.data.user.username) {
                        setLoginState(2)
                    } else {
                        history.push("/")
                    }

                }).catch(err => {
                    if (err.response && err.response.status) {
                        setLoading(false)
                        switch (err.response.status) {
                            case 400:
                                toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                                break;
                            case 404:
                                toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                                break;
                            case 401:
                                toast.error("Wir können dich grade nicht einloggen. Bitte versuche es später noch einmal.")
                                break;
                            default:
                                toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                                break;
                        }
                    }
                })

                return;
            case 2:
                axios({
                    method: "patch",
                    url: Endpoints.CHANGE_USER,
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    data: {
                        username: username
                    }
                }).then(res => {
                    setLoading(false)
                    dispatch({
                        type: "change_username", payload: {
                            username: username,
                        }
                    })
                    history.push("/")
                }).catch(err => {
                    if (err.response && err.response.status) {
                        setLoading(false)
                        switch (err.response.status) {
                            case 400:
                                toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                                break;
                            case 404:
                                toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                                break;
                            case 401:
                                toast.error("Du musst dich erneut einloggen")
                                history.push("/logout")
                                break;
                            default:
                                toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                                break;
                        }
                    }
                })

                return;
        }
    }

    switch (loginState) {
        case 1:
            return (
                <Layout>
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="card-title text-center mb-4"><FontAwesomeIcon className="text-primary"
                                                                                         icon={["fas", "lock"]}/> Login
                            </h2>

                            <div className="card-text text-center">
                                Um deine Anmeldung abzuschließen, benötigst du nun deinen <b>Magischen Login Token</b>.
                                Den haben wir dir bereits an deine E-Mail Adresse <code>{email}</code> geschickt. Ab und
                                zu findet eine
                                unserer Tauben nicht den richtigen Weg, wenn du also nach <b>5 min</b> noch keine E-Mail
                                erhalten hast,
                                dann lade die Seit neu und probier es nochmal. Wenn du dich bei deiner E-Mail Adresse
                                vertippt hast, dann kannst du mit "<b>Zurück</b>" jeder Zeit zurück.
                            </div>

                            <form ref={ref} onSubmit={e => onLogin(e)} className={cn({"was-validated": validated})}>
                                <FormInput required pattern="^[0-9]{6}$" maxLength={6} minLength={6}
                                           prefix={<FontAwesomeIcon className="text-primary" icon={["fas", "key"]}/>}
                                           setValue={setOTP} value={otp} placeholder="123456"
                                           info="Hier musst du deinen Magichen Login Token (MLT) eingeben."/>

                                <div className="row">
                                    <div className="col">
                                        <button type="button" onClick={e => onBack(e)}
                                                className="btn btn-primary text-light">Zurück
                                        </button>
                                    </div>
                                    <div className="col d-flex justify-content-end ">
                                        <div className="btn-group">
                                            <button type="submit" disabled={loading}
                                                    className="btn btn-primary text-light">{
                                                loading ? (
                                                    <FontAwesomeIcon className="fa-pulse" icon={["fas", "spinner"]}/>
                                                ) : (
                                                    "Anmelden"
                                                )
                                            }</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Layout>
            )

        case 2:
            return (
                <Layout>
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="card-title text-center mb-4"><FontAwesomeIcon className="text-primary"
                                                                                         icon={["fas", "lock"]}/> Login
                            </h2>

                            <div className="card-text text-center">
                                Wir freuen uns immer über neue Leute die Joshirando nutzen möchten. Damit deine Kollegen
                                dich auch direkt erkennen bitten wir dich darum uns deinen Namen mitzuteilen. Quasi als
                                Benutzernamen...
                            </div>

                            <form ref={ref} onSubmit={e => onLogin(e)} className={cn({"was-validated": validated})}>
                                <FormInput required type="text" minLength={2} maxLength={32}
                                           prefix={<FontAwesomeIcon className="text-primary" icon={["fas", "user"]}/>}
                                           pattern="^[\w\u00C0-\u00FF \.-]+$"
                                           setValue={setUsername} value={username}
                                           info="Gib hier bitte deinen gewünschten Nutzernamen ein."/>


                                <div className="row">
                                    <div className="d-flex justify-content-end ">
                                        <button type="submit" disabled={loading}
                                                className="btn btn-primary text-light">{
                                            loading ? (
                                                <FontAwesomeIcon className="fa-pulse" icon={["fas", "spinner"]}/>
                                            ) : (
                                                "Speichern"
                                            )
                                        }</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Layout>
            )

        default:
            return (
                <Layout>
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="card-title text-center mb-4"><FontAwesomeIcon className="text-primary"
                                                                                         icon={["fas", "lock"]}/> Login
                            </h2>

                            <div className="card-text text-center">
                                Wir von Joshirando halten nichts von herkömmlichen Login Methoden, wir setzen deshalb
                                auf <b>Passwort freie Login Verfahren</b> um dir eine hohe Sicherheit und den
                                bestmöglichen Komfort zu bieten. Jede E-Mail Adresse ist einem Account zugeordnet,
                                weswegen du dich auch nicht extra registrieren musst. Gib einfach unten deine <b>E-Mail
                                Adresse</b> an und wir leiten dich zum zweiten Schritt unseres Login Verfahrens weiter.
                            </div>

                            <form ref={ref} onSubmit={e => onLogin(e)} className={cn({"was-validated": validated})}>
                                <FormInput required type="email" minLength={1} maxLength={255}
                                           prefix={<FontAwesomeIcon className="text-primary"
                                                                    icon={["fas", "envelope"]}/>}
                                           info="Hier musst du deine E-Mail Adresse eintragen." setValue={setEmail}
                                           value={email} placeholder="joshi.rando@example.com"/>
                                <button type="submit" disabled={loading}
                                        className="btn btn-primary float-end text-light">{
                                    loading ? (
                                        <FontAwesomeIcon className="fa-pulse" icon={["fas", "spinner"]}/>
                                    ) : (
                                        "Anmelden"
                                    )
                                }</button>
                            </form>
                        </div>
                    </div>
                </Layout>
            )
    }
}

export default LoginView